/* AWARE - abre o carrinho lateral quando o endereco traz ?abrircarrinho=1
   Usado pelos lembretes de carrinho abandonado por SMS.
   Nao faz absolutamente nada em qualquer outra visita. */
(function () {
  'use strict';

  try {
    if (new URLSearchParams(window.location.search).get('abrircarrinho') !== '1') {
      return;
    }
  } catch (e) {
    return;
  }

  var tentativas = 0;

  function tentarAbrir() {
    var gaveta = document.querySelector('cart-drawer');

    if (gaveta) {
      if (typeof gaveta.open === 'function') {
        gaveta.open();
        return true;
      }
      /* Alguns temas nao expoem open(): a classe active abre na mesma. */
      gaveta.classList.add('active');
      return true;
    }
    return false;
  }

  function arrancar() {
    if (tentarAbrir()) { return; }

    var timer = setInterval(function () {
      if (tentarAbrir() || ++tentativas > 40) {
        clearInterval(timer);   /* desiste ao fim de 10s; a pagina fica normal */
      }
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }
})();
